import axios from 'axios';
import api from '../service/caller'

// Fonction pour récupérer l'ID utilisateur à partir du token
export const getUserIdFromToken = () => {
    const token = localStorage.getItem('access_token'); // Récupérer le token depuis le localStorage
    if (token) {
        const decodedToken = JSON.parse(atob(token.split('.')[1])); // Décoder le payload du JWT
        return decodedToken.userId; // Retourner l'ID de l'utilisateur (assurez-vous que c'est bien ce qui est stocké dans le token)
    }
    return null; // Retourne null si aucun token n'est présent
};